import { logger } from "@nosto/search-js/utils"

type Key = `nosto:search-templates:${string}`

function setStorage(name: Key, value: unknown, storage: Storage) {
    const stringValue = JSON.stringify(value)
    try {
        storage.setItem(name, stringValue)
    } catch (error) {
        logger.warn(error)
    }
}

function getStorage<T>(name: Key, storage: Storage) {
    let dataString
    try {
        dataString = storage.getItem(name)
    } catch (error) {
        logger.warn(error)
        return undefined
    }
    if (!dataString) {
        return undefined
    }
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return JSON.parse(dataString) as T
    } catch (error) {
        logger.warn(`cannot parse JSON- ${error} (${dataString})`)
        return undefined
    }
}

function removeStorage(name: Key, storage: Storage) {
    try {
        storage.removeItem(name)
    } catch (error) {
        logger.warn(error)
    }
}

export function setLocalStorageItem(name: Key, value: unknown) {
    setStorage(name, value, localStorage)
}

export function setSessionStorageItem(name: Key, value: unknown) {
    setStorage(name, value, sessionStorage)
}

export function getLocalStorageItem<T>(name: Key) {
    return getStorage<T>(name, localStorage)
}

export function getSessionStorageItem<T>(name: Key) {
    return getStorage<T>(name, sessionStorage)
}

export function removeLocalStorageItem(name: Key) {
    removeStorage(name, localStorage)
}

export function removeSessionStorageItem(name: Key) {
    removeStorage(name, sessionStorage)
}
